import { validateBr } from 'js-brasil'
import { onlyNumerics } from './sanitize'

export function isCnpj(value: string): boolean {
  return validateBr.cnpj(value)
}

export function isCpf(value: string): boolean {
  return validateBr.cpf(value)
}

export function getDocumentType(value: string): 'CPF' | 'CNPJ' | 'UNKNOWN' {
  const valueSanitized = onlyNumerics(value)

  if (valueSanitized.length === 11) {
    return 'CPF'
  }

  if (valueSanitized.length === 14) {
    return 'CNPJ'
  }

  return 'UNKNOWN'
}
